import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export const PrivateRoute = () => {
  const { authenticated, loadingSession } = useAuth()
  const location = useLocation()

  if (loadingSession) {
    return (
      <Box className="auth-loading">
        <CircularProgress color="primary" />
        <Typography>Comprobando sesión...</Typography>
      </Box>
    )
  }

  return authenticated
    ? <Outlet />
    : <Navigate to="/login" replace state={{ from: location }} />
}
